// extracted by mini-css-extract-plugin
export default {"overlay":"xz-z","bodyOpen":"yz-z","content":"zz-z","header":"Az-z","close":"Bz-z","closeNoHeading":"Cz-z"};